module.exports = __webpack_public_path__ + "img/ka.a5234f32.svg";